// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonScrollTop_root__DD2Bn"};